const useSiteMetadata = () => ({
  title: 'Gremlin',
  description:
    "Downtime is expensive and damages customer trust. Gremlin's platform finds weaknesses in your system before they cause problems.",
  siteUrl: 'https://www.gremlin.com',
  twitter: '@gremlininc',
})

export default useSiteMetadata
